import { FC } from 'react'

import { ReviewArtifactCardProps } from './ReviewArtifactCard.types'
import { ReviewCard } from './ReviewCard'
import { RevokeCard } from './RevokeCard'

// Dispatcher — pending widgets go through ReviewCard (approve/decline +
// hosts + AI review); approved widgets go through RevokeCard (single
// destructive action, no editors).
export const ReviewArtifactCard: FC<ReviewArtifactCardProps> = ({
  artifact
}) =>
  artifact.review_status === 'approved' ? (
    <RevokeCard artifact={artifact} />
  ) : (
    <ReviewCard artifact={artifact} />
  )
